<template>
  <div class="detail-container">
    <div class="detail" style="background: white;">
      <div class="detail-topbar px-4 d-flex justify-end">
        <div class="all-center">
          <v-btn
            @click="downloadSDF"
            v-if="showWhat === 'mole'"
            class="mr-4"
            height="24"
            color="#3f57bb"
            outlined
          >
            {{ $i18n.t("detail.Download") }} SDF
          </v-btn>
          <v-btn
            @click="downloadCIF"
            v-else
            class="mr-4"
            height="24"
            color="#3f57bb"
            outlined
          >
            {{ $i18n.t("detail.Download") }} CIF
          </v-btn>
          <!--          <v-btn class="mr-4" height="24" color="#3f57bb" outlined>复制计算属性</v-btn>-->
          <!--          <v-btn class="" height="24" color="#3f57bb" outlined>复制识别信息</v-btn>-->
        </div>
      </div>
      <v-row class="px-4">
        <v-col
          cols="12"
          md="12"
          lg="6"
          style="position: relative;"
          class="d-flex flex-column justify-start align-center"
        >
          <h2>{{ detail.title }}</h2>
          <MoleDrawer
            style="flex-grow: 1; border: 1px solid #d9d9d9;"
            @closeLoading="closeLoading"
            v-if="showMoleDraw"
            :detail="innerDetail"
          >
          </MoleDrawer>
          <div
            v-show="loading && !showTips"
            style="
              z-index: 1;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 200px;
              height: 200px;
              background: white;
            "
            class="all-center"
          >
            <v-progress-circular
              :size="50"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          <div v-if="showTips" class="all-center" style="flex-grow: 1;">
            <h3>
              晶体过于复杂,浏览器无法加载
            </h3>
          </div>
        </v-col>
        <v-col cols="12" md="12" lg="6" class="flex-grow-0 d-flex flex-column">
          <h2>{{ $i18n.t("detail.calculating_properties") }}</h2>
          <div
            class="list-wrapper"
            v-if="showWhat === 'crystal'"
            style="height: 500px; flex-grow: 1;"
          >
            <div
              class="list-item"
              v-for="calculate in calculates"
              :key="calculate.type"
            >
              <div class="list-item-left">
                {{ $i18n.t("detail." + calculate.type) }}
              </div>
              <div class="list-item-right">
                {{ calculate.value }}{{ calculate.unit }}
              </div>
            </div>
          </div>
          <div class="list-wrapper" v-if="showWhat === 'mole'">
            <div
              class="list-item"
              v-for="calculate in detail.cp"
              :key="calculate.type"
            >
              <div class="list-item-left" style="width: 65%;">
                {{ $i18n.t(calculate.key) }}
              </div>
              <div class="list-item-right" style="width: 35%;">
                {{ calculate.value }}{{ calculate.unit }}
              </div>
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          lass="flex-grow-0 d-flex flex-column"
          v-if="showWhat === 'mole'"
        >
          <h2>{{ $i18n.t("detail.identify_information") }}</h2>
          <div class="list-wrapper">
            <div
              class="list-item"
              v-for="(item, index) in detail.ii"
              :key="item.key + index"
              style="height: 32px;"
            >
              <div class="list-item-left" style="width: 20%;">
                {{ item.key }}
              </div>
              <div
                class="list-item-right"
                style="width: 80%; white-space: nowrap; overflow: hidden;"
              >
                {{ item.str_value }}
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" v-if="showWhat === 'mole'">
          <h2>{{ $i18n.t("detail.alias") }}</h2>
          <div style="border: 1px solid #999; padding: 10px;">
            <span
              v-for="tag in detail.synonyms"
              :key="tag"
              class="common-font-black-bold"
              style="margin: 5px; background: #e7e7e7; line-height: 30px;"
            >
              {{ tag }}
            </span>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

const fileDownload = require("js-file-download");

export default {
  name: "Detail",
  components: {},
  data() {
    return {
      innerDetail: {},
      structure: {},
      calculates: [],
      showMoleDraw: false,
      showTips: false,
      loading: true,
      showWhat: "mole",
    };
  },
  computed: {
    ...mapState(["listWhat", "detail"]),
  },
  created() {
    // let data = window.localStorage.getItem("detailId")
    let data;
    if (this.$route.query.id.indexOf("COD") === -1) {
      this.SET_LISTWHAT("mole");
      this.showWhat = "mole";
      data = [{ label: this.$route.query.id, type: "id" }];
      document.title = "大材库-分子详情显示页";
    } else {
      document.title = "大材库-晶体详情显示页";
      this.SET_LISTWHAT("crystal");
      this.showWhat = "crystal";
      data = { label: this.$route.query.id, type: "id" };
    }
    this.getDetail(data)
      .then((res) => {
        if (res.data.code === 604 || res.data.code === 701) {
          this.$router.push("/");
        }

        this.innerDetail = res;
        let volume;
        res.data.replace(/_cell_volume\s+(\d+.?\d+)/, function (e) {
          let arr = e.split(" ");
          volume = arr[arr.length - 1].split("(")[0] - 0;
        });

        if (this.detail.type === "CIF") {
          if (volume > 25000) {
            this.showMoleDraw = false;
            this.showTips = true;
          } else {
            this.showMoleDraw = true;
            this.showTips = false;
          }
        } else {
          this.showMoleDraw = true;
          this.showTips = false;
        }

        this.calculates = [];
        if (this.detail.type === "CIF") {
          this.calculates.push({ type: "Formula", value: this.detail.title });
          this.calculates.push({
            type: "pointGroup",
            value: this.detail.pointGroup,
          });
          this.calculates.push({
            type: "spaceGroup",
            value: this.detail.spaceGroup,
          });
          this.calculates.push({ type: "system", value: this.detail.system });
          this.calculates.push({ type: "a", value: this.detail.unitCell.a });
          this.calculates.push({ type: "b", value: this.detail.unitCell.b });
          this.calculates.push({ type: "c", value: this.detail.unitCell.c });
          this.calculates.push({
            type: "alpha",
            value: this.detail.unitCell.alpha,
          });
          this.calculates.push({
            type: "beta",
            value: this.detail.unitCell.beta,
          });
          this.calculates.push({
            type: "gamma",
            value: this.detail.unitCell.gamma,
          });
        }
      })
      .catch(() => {
        this.$router.push("/");
      });
  },

  methods: {
    ...mapMutations(["SET_LISTWHAT"]),
    ...mapActions(["getDetail", "download"]),
    downloadSDF() {
      fileDownload(this.detail.data, "export.sdf");
    },
    downloadCIF() {
      fileDownload(this.detail.data, "export.cif");
    },
    closeLoading() {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.detail-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  .detail {
    display: flex;
    flex-direction: column;
    margin: 20px 15%;
    flex-grow: 1;

    h2 {
      padding-bottom: 8px;
    }

    .detail-topbar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 72px;
      border-bottom: 1px solid rgb(232, 235, 240);

      &-back {
        height: 40px;
        color: #3f57bb;
      }
    }

    .list-wrapper {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      border: 1px solid;
      border-bottom: transparent;

      .list-item {
        display: flex;
        align-items: center;
        flex-grow: 1;
        height: 32px;
        border-bottom: 1px solid;

        &-left {
          height: 100%;
          justify-content: center;
          display: flex;
          align-items: center;
          width: 50%;
          border-right: 1px solid;
        }

        &-right {
          display: flex;
          width: 50%;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}
</style>
